module.exports = __webpack_public_path__ + "img/customers_tubeRight.d861dc33.png";